export const DEVICE_DETECTION_TYPE_DESKTOP = 'desktop';
export const DEVICE_DETECTION_TYPE_MOBILE = 'mobile';
export const DEVICE_TYPE_DESKTOP = 'c';
export const DEVICE_TYPE_MOBILE = 'm';
